import React,{useEffect} from 'react';
import ContactUsSlide from "./ContactUsSlide";
import DancePartyWithFriendsSlide from "./DancePartyWithFriendsSlide";
import DrawSlide from "./DrawSlide";
import DrawWithFriendsSlide from "./DrawWithFriendsSlide";

import FAQSlide from "./FAQSlide";

import TwentyQuestionsSlide from "./TwentyQuestionsSlide";
//import UpcomingEventsSlide from "./UpcomingEventsSlide";
import WatchFromNextRoomSlide from "./WatchFromNextRoomSlide";
//import WhatAreInvitationsSlide from "./WhatAreInvitationsSlide";
import DancePartyFrontPanelREF from "./DancePartyFrontPanelREF";

import EmailDrawingsSlide from "src/components/TDP/FrontSliders/EmailDrawingsSlide.js";
import SaveDrawingToFridgeSlide from "src/components/TDP/FrontSliders/SaveDrawingToFridgeSlide.js";
import TerminologySlide from "src/components/TDP/FrontSliders/TerminologySlide.js";
//import FrontSliderBlurb from "src/components/TDP/FrontSliders/FrontSliderBlurb.js";
//import EmailDrawingSlide from "./EmailDrawingSlide";
//import PublicFridgeSlide from "./PublicFridgeSlide";
//import DrawWithFriends2 from "src/components/TDP/FrontSliders/DrawWithFriendsSlide.js";
export const SlideArray = (height) => {

    return ([
        <DancePartyFrontPanelREF key={"DPFPR"} height={height}/>,
        <TerminologySlide key={"TERM"} height={height}/>,
        <DrawSlide key={"DS"} height={height}/>,
        <DrawWithFriendsSlide key={"DWF"} height={height}/>,
        <DancePartyWithFriendsSlide key={"DPWF"} height={height}/>,
        <EmailDrawingsSlide key={"EmailDraw"} height={height}/>,
        <SaveDrawingToFridgeSlide key={"SaveDrawingFridge"} height={height}/>,
        <TwentyQuestionsSlide key={"20q"} height={height}/>,
        <WatchFromNextRoomSlide key={"watchFronNextRoom"} height={height}/>,
        <ContactUsSlide key={"contact"} height={height}/>,
        <FAQSlide key={"FAQ"} height={height}/>,

    ])
};

/*
        <WhatAreInvitationsSlide key={"invitations"}/>,
        <UpcomingEventsSlide key={"upcomingevents"}/>,
 */

/* Almost Ready
 <PublicFridgeSlide key={"publicFridge"}/>,
 */
const defaultStyle={height:"100%",width:"100vw", maxHeight:"100%"};

const KidsLifeSlider = (props) => {
    useEffect(()=>{
        //eslint-disable-next-line
        processPage(jQuery);
        //eslint-disable-next-line
        doSlider();
    },[]);

    return (
    <div id="main" style={Object.assign({},defaultStyle,{height:props.height,maxHeight:props.height})}>
        <div id="slider" style={Object.assign({},defaultStyle,{height:props.height,maxHeight:props.height})}>
            <div id="layerslider_4" className="ls-wp-container" style={{width:"100%",height:props.height,maxheight:"610px",maxWidth:"1920px",margin:"0 auto",marginBottom: "0px"}}>
                {SlideArray(props.height)}
            </div>
        </div>
    </div>
    )
};

export default KidsLifeSlider
